// 261023 E3-P3h3 — báo cho vỏ biết «dải có nút chính bấm được» để `ctaOwnerOf` quyết ai được đỏ (đúng MỘT nút đỏ mỗi màn). Không vẽ gì; gỡ khoá khi dải biến mất.
import React, { useEffect } from 'react';
import { useWorkbenchCtx } from './WorkbenchContext';

const BandCtaReporter: React.FC<{ id: string; active: boolean }> = ({ id, active }) => {
  const { setBandCta } = useWorkbenchCtx();
  useEffect(() => { setBandCta(id, active); return () => setBandCta(id, false); }, [id, active, setBandCta]);
  return null;
};

export default BandCtaReporter;
